import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import { getIsPrecogSuspended, portalHealthStatusSelector
// @ts-expect-error Could not find a declaration for module ...
} from 'EmailData/portalStatus/selectors';
import { SUSPENSION_APPEAL_STATUS } from 'EmailData/constants/portalSuspension';
import { useAppSelector } from 'EmailData/reducers/types';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PortalSuspensionBadge() {
  const isSuspended = useAppSelector(getIsPrecogSuspended);
  const status = useAppSelector(portalHealthStatusSelector);
  if (!isSuspended) {
    return null;
  }

  // @ts-expect-error object is of type unknown
  if (status.getAppealState() === SUSPENSION_APPEAL_STATUS.PENDING) {
    return /*#__PURE__*/_jsx(UIBadge, {
      className: "m-left-2",
      use: "lorax",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.header.tabs.accountSuspensionBadge.underReview"
      })
    });
  }
  return /*#__PURE__*/_jsx(UIBadge, {
    className: "m-left-2",
    use: "candy-apple",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "EmailComponents.header.tabs.accountSuspensionBadge.suspended"
    })
  });
}